var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropertyDisclousre({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Properties_-_Flaticon-2",
    "data-name": "Search results for Properties - Flaticon-2",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10041",
    "data-name": "Group 10041",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9844",
    "data-name": "Path 9844",
    d: "M40.415,45a4.415,4.415,0,1,0,4.415,4.415A4.42,4.42,0,0,0,40.415,45Zm0,5.886a1.472,1.472,0,1,1,1.472-1.472A1.472,1.472,0,0,1,40.415,50.886Z",
    transform: "translate(14.732 18.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9845",
    "data-name": "Path 9845",
    d: "M7,60.772H18.773V49H7Zm2.943-8.829H15.83v5.886H9.944Z",
    transform: "translate(1.83 20.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9846",
    "data-name": "Path 9846",
    d: "M91,16.367,75.633,1h-42.7V12.613H18.419v1.452a7.254,7.254,0,1,1-.97-3.628l2.511-1.455a10.161,10.161,0,1,0,1.259,6.534H32.935V35.839H18.419V37.29a7.254,7.254,0,1,1-.97-3.628l2.511-1.455a10.161,10.161,0,1,0,1.259,6.534H32.935v9.285L27.13,44.27,1,61.177v3.694H3.9V91H73.581V79.387H91Zm-8.71,2.053v5.806H41.645V9.71H73.581v8.71Zm-5.806-2.9V5.956l9.56,9.56Zm2.786,52.7a4.332,4.332,0,0,0-1.955-2.7l-8.753-5.385A7.251,7.251,0,1,1,79.378,69.2,4.4,4.4,0,0,0,79.27,68.218Zm-3.478-.231a1.45,1.45,0,0,1,.476,2,1.479,1.479,0,0,1-2,.475L56.161,59.317,38.051,70.463a1.48,1.48,0,0,1-2-.473,1.453,1.453,0,0,1,.476-2L55.4,56.376a1.471,1.471,0,0,1,1.515,0Zm-35.016-6.02H28.582v-13.3L45.061,59.33Zm-15.1-13.3v13.3H5.125ZM6.808,64.871h29.25l-1.048.645a4.343,4.343,0,0,0-1.82,5.16H24.227V82.289H35.84V73.3a4.044,4.044,0,0,0,2.9.019V88.1H6.808Zm26.129,8.71v5.806H27.13V73.581ZM61.968,88.1H50.355v-8.71H61.968Zm2.9,0V76.484H47.452V88.1H41.645V71.66l14.516-8.935,14.516,8.933V88.1Zm8.71-11.613V73.321a4.355,4.355,0,0,0,1.45.26h0A10.161,10.161,0,1,0,66.09,58.61L58.439,53.9a4.415,4.415,0,0,0-4.558,0L47.8,57.645l-11.96-7.739V3.9H73.581v2.9H38.742V27.129H85.194v-8.71h2.9V76.484Z",
    transform: "translate(-1 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9847",
    "data-name": "Path 9847",
    d: "M8.276,28.139l-1.9-1.9L4.293,28.317,8.276,32.3,15.2,25.374l-2.081-2.081Z",
    transform: "translate(0.553 9.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9848",
    "data-name": "Path 9848",
    d: "M8.276,12.139l-1.9-1.9L4.293,12.317,8.276,16.3,15.2,9.374,13.122,7.293Z",
    transform: "translate(0.553 1.967)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9849",
    "data-name": "Path 9849",
    d: "M27,29.829h8.829V21H27Zm2.943-5.886h2.943v2.943H29.943Z",
    transform: "translate(10.686 7.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9850",
    "data-name": "Path 9850",
    d: "M35,21h2.943v2.943H35Z",
    transform: "translate(14.332 8.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9851",
    "data-name": "Path 9851",
    d: "M39,21H68.431v2.943H39Z",
    transform: "translate(15.683 8.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9852",
    "data-name": "Path 9852",
    d: "M35,25H70.317v2.943H35Z",
    transform: "translate(13.797 9.823)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9853",
    "data-name": "Path 9853",
    d: "M27,37.829h8.829V29H27Zm2.943-5.886h2.943v2.943H29.943Z",
    transform: "translate(10.686 11.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9854",
    "data-name": "Path 9854",
    d: "M57,33h2.943v2.943H57Z",
    transform: "translate(24.171 13.43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9855",
    "data-name": "Path 9855",
    d: "M35,33H64.431v2.943H35Z",
    transform: "translate(13.797 13.43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9856",
    "data-name": "Path 9856",
    d: "M35,29H70.317v2.943H35Z",
    transform: "translate(13.797 11.627)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyDisclousre);
export default __webpack_public_path__ + "static/media/propertyDisclousre.7f6a6a2295aa93e347c817c1f452c2b5.svg";
export { ForwardRef as ReactComponent };